/* Ezzyrol core behaviour: final/ez.js. Loaded on every page after the partials.
   Mega menu (one open at a time), drawer, footer accordions, single or set switch, option value
   labels, quantity stepper and the phone sticky buy bar. No dependencies. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var desktop = window.matchMedia('(min-width: 1200px)');
  var wide = window.matchMedia('(min-width: 990px)');

  /* mega menu: native details, one open at a time; Escape and an outside click close it.
     The panel's scrim is its own clipped shadow, so no extra element is needed. */
  var menus = [].slice.call(doc.querySelectorAll('.ez-nav__item'));
  function closeMenus(except) { menus.forEach(function (m) { if (m !== except) m.open = false; }); }
  menus.forEach(function (m) {
    m.addEventListener('toggle', function () { if (m.open) closeMenus(m); });
  });
  doc.addEventListener('click', function (e) { if (!e.target.closest('.ez-nav')) closeMenus(); });

  /* drawer */
  var drawer = doc.getElementById('ez-drawer');
  var menuBtn = doc.querySelector('.ez-head__menu');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    if (menuBtn) menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.style.overflow = open ? 'hidden' : '';
    if (open) { var c = drawer.querySelector('.ez-drawer__close'); if (c) c.focus(); } else if (menuBtn) { menuBtn.focus(); }
    updateSticky();
  }
  if (menuBtn) menuBtn.addEventListener('click', function () { setDrawer(true); });
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('.ez-drawer__close')) setDrawer(false);
    });
  }
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMenus();
    if (drawer && !drawer.hidden) setDrawer(false);
  });

  /* footer: columns open on desktop, accordions on phones */
  function syncFooter() { doc.querySelectorAll('.ez-foot__cols details').forEach(function (d) { d.open = wide.matches; }); }
  syncFooter();
  wide.addEventListener('change', syncFooter);

  /* single case or luggage set: shows the matching size group */
  doc.querySelectorAll('.ez-seg').forEach(function (seg) {
    seg.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-ez-seg]'); if (!b) return;
      seg.querySelectorAll('button[data-ez-seg]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var scope = seg.closest('.ez-buy') || doc;
      scope.querySelectorAll('[data-ez-mode]').forEach(function (g) { g.hidden = g.getAttribute('data-ez-mode') !== b.getAttribute('data-ez-seg'); });
    });
  });

  /* option value next to its label ("Colour  Navy") */
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (t.type !== 'radio') return;
    var out = doc.querySelector('[data-ez-value="' + t.name + '"]');
    if (out) out.textContent = t.value;
  });

  /* quantity stepper */
  doc.querySelectorAll('.ez-qty').forEach(function (q) {
    var input = q.querySelector('input'), minus = q.querySelector('[data-ez-qty="-1"]');
    q.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ez-qty]'); if (!b) return;
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-ez-qty'), 10));
      input.value = v; if (minus) minus.disabled = v <= 1;
    });
  });

  /* sticky buy bar (phones): an IntersectionObserver on the main button plus a scroll position
     check, because the observer alone can misfire after a jump to the top. Hidden while the drawer
     is open and whenever the footer is on screen. */
  var atc = doc.getElementById('ez-atc');
  var bar = doc.querySelector('.ez-sticky:not(.ez-sticky--static)');
  var foot = doc.querySelector('.ez-foot');
  function updateSticky() {
    if (!atc || !bar) return;
    var a = atc.getBoundingClientRect();
    var f = foot ? foot.getBoundingClientRect().top : Infinity;
    var drawerOpen = drawer && !drawer.hidden;
    var on = !wide.matches && !drawerOpen && a.bottom < 0 && f > window.innerHeight;
    bar.setAttribute('data-visible', on ? 'true' : 'false');
  }
  if (atc && bar) {
    if ('IntersectionObserver' in window) new IntersectionObserver(updateSticky).observe(atc);
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    var stickyBtn = bar.querySelector('[data-ez-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { atc.click(); });
    updateSticky();
  }

  window.ezSetDrawer = setDrawer;
  window.ezUpdateSticky = updateSticky;
})();
